import * as React from "react";
import * as ReactDOM from "react-dom";

import { Closure } from "./components/Closure";

ReactDOM.render(
  <Closure />,
  document.getElementById("closure")
);
